export const MIN_NAME_LENGTH = 2

export const enum EmployeeActiveStatus {
  active = 'active',
  inactive = 'inactive',
}

export const enum AddingEmployeeType {
  all = 'all',
  some = 'some',
  only = 'only',
}

export const addingEmployeeOptions = [
  {
    value: AddingEmployeeType.only,
    label: 'Только в этом ПВЗ',
  },
  {
    value: AddingEmployeeType.some,
    label: 'В некоторых ПВЗ',
  },
  {
    value: AddingEmployeeType.all,
    label: 'Во всех ПВЗ',
  },
]

export const enum ELOCK_PERMISSIONS {
  none = 'ELOCK_ROLE_NONE',
  open = 'ELOCK_ROLE_OPEN',
  activate = 'ELOCK_ROLE_ACTIVATE',
  openAndActivate = 'ELOCK_ROLE_OPEN_ACTIVATE',
}

export const enum EmployeeKeys {
  employeeModule = 'employeeModule',
  employeePage = 'employeeModule.employeePage',
  addEmployeePage = 'employeeModule.addEmployeePage',
}
